import { action } from "../common/Action"
import { CaldaieClient } from "../generated";

const service = new CaldaieClient();

class TipiTiraggioActions {
    @action
    async getAll() {
        return (await service.getTipiTiraggio())!;
    };
}
export default new TipiTiraggioActions();